<div class="container-fluid">
    <div class="row">
        <div class="col-6 col-sm-3 bg-light img-wrapper border border-white p-2 " *ngFor="let media of allowedMedia">
            
            <img 
                [src]="fileImage(media)" 
                [alt]="media.title" 
                class="img-fluid"/>
            <small class="align-self-center text-center d-block">{{media.title}}</small>
            <div class="overlay">
                <a href="javascript:" (click)="deleteModal.show()"><i class="fas fa-trash mr-3 fa-lg text-white"></i></a>
                <a href="javascript:" (click)="selectFile(media)"><i class="fas fa-check fa-lg text-white"></i></a>
            </div>

            <app-ui-modal #deleteModal dialogClass="modal-dialog-centered">
                <div class="app-modal-header">
                <h5 class="modal-title">Sicuro di voler eliminare questo file?</h5>
                <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="deleteModal.hide()"><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="app-modal-body">
                    <p>
                        Attenzione! Proseguendo, il file non sarà più disponbile per tutti i contenuti che lo stanno utilizzando.
                    </p>
                </div>
                <div class="app-modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="deleteModal.hide();">Annulla</button>
                <button type="button" class="btn btn-primary" (click)="deleteModal.hide(); deleteImage(media);">Elimina</button>
                </div>
            </app-ui-modal>
        </div>
        <div class="col-12" *ngIf="!media?.length">
            <p class="mt-2">Nessun file è stato caricato nella gallery</p>
        </div>
    </div>
</div>

